<div>
  <loading *ngIf="loadingService.isLoading" ></loading>
  <!-- <sales-portal-header *ngIf="isSalesPortal;else elseblock"></sales-portal-header> -->
  <!-- <ng-template #elseblock> -->
  <app-app-header *ngIf="!isOfficialWebsite"></app-app-header>
  <official-website-header *ngIf="isOfficialWebsite"></official-website-header>
  <!-- </ng-template> -->


  <div
    class="app-content"
    [class.content_wrap_sales_portal]="isSalesPortal"
  >
    <sales-portal-nav *ngIf="isSalesPortal"></sales-portal-nav>
    <router-outlet></router-outlet>
  </div>
  <app-new-feature-guide *ngIf="isNewFeatureVisible" (guideCompleted)="handleNewFeatureGuideCompleted()"></app-new-feature-guide>
  <app-promotion-popup-window *ngIf="isStitchPromoVisible" (modalClosed)="handleStitchPromoClosed()"></app-promotion-popup-window>
  <app-app-footer *ngIf="!isSalesPortal && !isOfficialWebsite"></app-app-footer>
  <official-website-footer *ngIf="!isSalesPortal && isOfficialWebsite"></official-website-footer>

<app-chatbot *ngIf="!isProduction"></app-chatbot>

<!--Login Status not OK -->
<nz-modal
[(nzVisible)]="statusModalVisible"
nzCentered
[nzBodyStyle]="{'padding': '0px'}"
class="login-tip"
[nzFooter]="null"
[nzClosable]="false"
>
<div *nzModalContent>
  <button nz-button nzType="text" class="login-tip__close" (click)="closeLoginStatusModal()">
    <svg-icon [iconName]="'close.svg'" class="login-tip__close-x" [size]="20"></svg-icon>
  </button>
  <div class="login-tip__title sm:text-left mx:text-center">
    <div class="login-tip__title-welcome">Welcome to</div>
    <div class="login-tip__title-logo">
      <div class="sm:w-full">
        <img src="assets/Bosch_COLOR_RGB.png" alt="">
      </div>
      <div class="login-tip__title-divider sm:hidden"></div>
      <p class="sm:w-full">{{'CUSTOMER_PORTAL' | translate}}</p>
    </div>
  </div>
  <div class="login-tip__content sm:px-4 mx:px-8">
    <div class="login-tip__content-subtitle">{{'LOGIN_NO_ROLE_TIP_TITLE'| translate}}</div>
    <div class="login-tip__content-message">{{'LOGIN_NO_ROLE_TIP_CONTENT' | translate}}</div>
    <div class="login-tip__footer">
      <Button type="primary" class="primary-button login-tip__footer-button sm:w-full" (click)="closeLoginStatusModal()">
        {{'CONFIRM' | translate}}
      </Button>
    </div>
  </div>
</div>
</nz-modal>

<!--Need To agree privacy -->
<nz-modal
[(nzVisible)]="myConsentModalVisible"
nzCentered
class="login-tip"
[nzBodyStyle]="{'padding': '0px'}"
[nzFooter]="null"
(nzOnCancel)="false"
[nzClosable]="false"
nzWidth="900px"
>
<div *nzModalContent>
  <button nz-button nzType="text" class="login-tip__close" (click)="closePrivacyModal()">
      <svg-icon [iconName]="'close.svg'" class="login-tip__close-x" [size]="30"></svg-icon>
  </button>
  <div class="login-tip__title sm:text-left mx:text-center">
    <div class="login-tip__title-welcome">Welcome to</div>
    <div class="login-tip__title-logo">
      <div class="sm:w-full">
        <img src="assets/Bosch_COLOR_RGB.png" alt="">
      </div>
      <div class="login-tip__title-divider sm:hidden"></div>
      <p class="sm:w-full">{{'CUSTOMER_PORTAL' | translate}}</p>
    </div>
  </div>
  <div class="login-tip__content mx:px-8 sm:px-4">
    <div class="login-tip__content-subtitle">{{'MY_CONSENT'| translate}}</div>
    <div class="login-tip__content-message">{{'MY_CONSENT_CONTENT' | translate}}</div>
    <div class="login-tip__privacy">
      <div class="login-tip__privacy-item">
        <div class="login-tip__privacy-title">{{'PRIVACY_CROSS-BORDER' | translate}}*</div>
        <div>
          <label nz-checkbox [(ngModel)]="isAgreeCrossBorderTransfer">
            {{ 'CART_AGREE' | translate }} <span class="link" (click)="handleViewDataPrivacy($event)">{{'PRIVACY_CROSS-BORDER' | translate}}</span>
          </label>
        </div>
      </div>
      <div class="login-tip__privacy-item">
        <div class="login-tip__privacy-title">{{ 'PRIVACY_TERMS_OF_USE' | translate }}*</div>
        <div>
          <label nz-checkbox [(ngModel)]="isAgreeUserTerms">
            {{ 'CART_AGREE' | translate }} <span class="link" (click)="handleViewUserTerms($event)">{{ 'PRIVACY_TERMS_OF_USE' | translate }}</span>
          </label>
        </div>
      </div>
      <div class="login-tip__privacy-item">
        <div class="login-tip__privacy-title">{{ 'PRIVACY_STATEMENT' | translate }}*</div>
        <div>
          <label nz-checkbox [(ngModel)]="isAgreeDataPrivacy">
            {{ 'CART_AGREE' | translate }} <span class="link" (click)="handleViewDataPrivacy($event)">{{ 'PRIVACY_STATEMENT' | translate }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="login-tip__footer">
      <Button
        nz-button
        [disabled]="!(isAgreeCrossBorderTransfer&&isAgreeUserTerms&&isAgreeDataPrivacy)"
        (click)="handleClickAgreeAll()"
        class="primary-button login-tip__footer-button sm:w-full">
        {{'AGREE' | translate}}
      </Button>
    </div>
  </div>
</div>
</nz-modal>
<nz-modal [(nzVisible)]="isReloginVisible" nzTitle="{{'SYSTEM_HAS_CHANGED' | translate}}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <p style="padding-top: 20px;"> {{'SYSTEM_HAS_CHANGED_CONTENT' | translate}}</p>
  </ng-container>
</nz-modal>
</div>
